import { RepositoryMain } from "../Domain/RepositoryMain";

export class UseCaseRespuestaConexionFirma {
    private repository: RepositoryMain;

    constructor(_repository: RepositoryMain) {
        this.repository = _repository;
    }

    public async exec(params: boolean): Promise<any> {
        return await this._exec(params);
    }

    private async _exec(params: boolean): Promise<any> {
        return await this.repository.respuestaConexionFirma(params);
    }
}